import React from 'react';
import './Footer.css';
import 'bootstrap/dist/css/bootstrap.css';
import Navigation from './Navigation';
import VoiceflowChat from './VoiceflowChat';

const Footer = () => {
  return (
    <footer className="footer bg-dark text-white">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h1>Welcome to Mustang Electric, LLC</h1>
            <p>Your trusted partner for electrical services.</p>
            <address>
              <p>Contact Information:</p>
              <p>Phone: (123) 456-7890</p>
              <p>Email: info@mustangelectric.com</p>
              <p>Address: 1234 Main Street, City, State</p>
            </address>
          </div>
          <div className="col-md-6">
            <Navigation />
            <p className="text-center">
              &copy; {new Date().getFullYear()} Mustang Electric, LLC
              <br />
              All Rights Reserved
            </p>
          </div>
        </div>
      </div>
      <VoiceflowChat />
    </footer>
  );
};

export default Footer;


